import { useState, useEffect, useRef } from "react";
const stats = [{
  value: "96%",
  label: "zufriedene Kunden"
}, {
  value: "73%",
  label: "Start innerhalb einer Woche"
}, {
  value: "79%",
  label: "Weiterempfehlungsrate"
}, {
  value: "15+",
  label: "Jahre Erfahrung"
}];
export default function StatsBar() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) setVisible(true);
    }, {
      threshold: 0.1
    });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  useEffect(() => {
    if (window.innerWidth >= 768) return;
    let interval: NodeJS.Timeout;
    const startInterval = () => {
      interval = setInterval(() => {
        if (!isPaused && ref.current) {
          setCurrentSlide(prev => {
            const next = (prev + 1) % stats.length;
            const scrollAmount = next * (window.innerWidth - 32);
            ref.current!.scrollLeft = scrollAmount;
            return next;
          });
        }
      }, 5000);
    };
    startInterval();
    const handleTouchStart = () => {
      setIsPaused(true);
      clearInterval(interval);
    };
    const handleTouchEnd = () => {
      setTimeout(() => {
        setIsPaused(false);
      }, 2000);
    };
    const carousel = ref.current;
    if (carousel) {
      carousel.addEventListener("touchstart", handleTouchStart);
      carousel.addEventListener("touchend", handleTouchEnd);
    }
    return () => {
      clearInterval(interval);
      if (carousel) {
        carousel.removeEventListener("touchstart", handleTouchStart);
        carousel.removeEventListener("touchend", handleTouchEnd);
      }
    };
  }, [isPaused]);
  return;
}